const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
          entriesByHour: "Entries by hour",
          pendingByHour: "Waiting tickets by hour",
          ticketsLabel: "Entries",
          pendingLabel: "Waiting"
        },
        metrics: {
          title: "Ticket metrics",
          exactFrom: "Exact data since status tracking activation",
          infoClose: "Close",
          range: {
            label: "Range",
            today: "Today",
            yesterday: "Yesterday",
            last7Days: "Last 7 days",
            last30Days: "Last 30 days",
            last90Days: "Last 90 days"
          },
          filters: {
            firstResponseTarget: "1st response target (min)",
            resolutionTarget: "Resolution target (min)"
          },
          firstResponseTime: "Average first response",
          firstResponseP50: "First response P50",
          firstResponseP90: "First response P90",
          resolutionTime: "Average resolution time",
          resolutionP50: "Resolution P50",
          resolutionP90: "Resolution P90",
          pendingTime: "Average waiting time",
          pendingP50: "Waiting P50",
          pendingP90: "Waiting P90",
          openTime: "Average in-service time",
          openP50: "In-service P50",
          openP90: "In-service P90",
          slaFirstResponse: "First response SLA",
          slaResolution: "Resolution SLA",
          peakEntryHour: "Peak entry hour",
          peakPendingHour: "Peak waiting hour",
          topResolvers: "Users with most resolved tickets",
          table: {
            user: "User",
            resolved: "Resolved",
            avgFirstResponse: "Avg 1st response",
            avgResolution: "Avg. resolution",
            slaFirstResponse: "1st resp. SLA",
            slaResolution: "Resolution SLA",
            reopened: "Reopens",
            active: "Active",
            avgPerTicket: "Avg. time per ticket",
            noData: "No data for this range"
          },
          descriptions: {
            firstResponseTime: "Average time from ticket creation until it first moves into in-service status.",
            firstResponseP50: "First response P50: half of tickets are first attended within this time.",
            firstResponseP90: "First response P90: 90% of tickets are first attended within this time.",
            slaFirstResponse: "Percentage of tickets meeting the configured first response target.",
            slaResolution: "Percentage of resolved tickets meeting the configured resolution target.",
            peakEntryHour: "Hour slot with the highest number of incoming tickets for the selected range.",
            peakPendingHour: "Hour slot with the highest waiting-ticket load in the selected range.",
            resolutionTime: "Average total time from ticket creation to ticket closure.",
            resolutionP50: "Resolution P50: half of tickets are resolved within this time.",
            resolutionP90: "Resolution P90: 90% of tickets are resolved within this time.",
            pendingTime: "Average accumulated time each ticket spends in waiting status.",
            pendingP50: "Waiting-time P50 per ticket.",
            pendingP90: "Waiting-time P90 per ticket.",
            openTime: "Average accumulated time each ticket spends in in-service status.",
            openP50: "In-service-time P50 per ticket.",
            openP90: "In-service-time P90 per ticket.",
            topResolvers: "Ranking of users with most resolved tickets and their average timing metrics."
          },
          examples: {
            firstResponseTime: "Example: ticket arrives at 10:00 and is first handled at 10:12 -> first response = 12 min.",
            firstResponseP50: "Example: P50 = 8 min means half of tickets are first handled in <= 8 min.",
            firstResponseP90: "Example: P90 = 25 min means 90% of tickets are first handled in <= 25 min.",
            slaFirstResponse: "Example: target 15 min and SLA 82% means 82 out of 100 tickets were handled in <= 15 min.",
            slaResolution: "Example: target 1440 min and SLA 76% means 76 out of 100 tickets were resolved in <= 1440 min.",
            peakEntryHour: "Example: 11:00 (34) means 34 tickets entered between 11:00 and 11:59.",
            peakPendingHour: "Example: 15:00 (18) means 18 distinct tickets were waiting in that hour slot.",
            resolutionTime: "Example: ticket enters at 09:00 and closes at 13:30 -> resolution = 4 h 30 min.",
            resolutionP50: "Example: P50 = 2 h means half of tickets are resolved in <= 2 h.",
            resolutionP90: "Example: P90 = 14 h means 90% of tickets are resolved in <= 14 h.",
            pendingTime: "Example: if a ticket waited 20 min and later waited 10 more min, total waiting = 30 min.",
            pendingP50: "Example: waiting P50 = 12 min means half of tickets waited <= 12 min.",
            pendingP90: "Example: waiting P90 = 55 min means 90% of tickets waited <= 55 min.",
            openTime: "Example: sum of all in-service intervals for a ticket.",
            openP50: "Example: in-service P50 = 40 min means half of tickets spent <= 40 min in service.",
            openP90: "Example: in-service P90 = 3 h 10 min means 90% spent <= that time in service.",
            topResolvers: "Example: a user with 120 resolved tickets and lower average resolution time ranks higher."
          }
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        closedSearch: {
          placeholder: "Search by name or contact",
        },
        buttons: {
          showMine: "Mine",
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select a queue",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Search a contact or type a number",
        add: "Add",
        addNumber: "Open chat with",
        countryCode: "Country code",
        connection: "Line",
        buttons: {
          ok: "Send",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          queues: "Queues",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
          systemChecks: "System Checks",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          whatsapp: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          ticketLockByAgent: {
            name: "Agent ownership lock",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      appUpdate: {
        message: "A new version is available.",
        warning: "Updating will sign you out and clear local app data.",
        action: "Update now",
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            transfer: "Transfer",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
      },
    },
  },
};

export { messages };
